import React from 'react';
import styles from './loader.module.scss';
import classNames from 'classnames';

const Loader = () => {
    return (
        <div className={styles.loaderContainer}>
            <div className={styles['loader-wrapper']}>
                <div className={styles.loader}></div>
                <div className={classNames(styles['loader-section'], styles['section-left'])}></div>
                <div className={classNames(styles['loader-section'], styles['section-right'])}></div>
            </div>
        </div>

    );
};

export default Loader;